import { extractVariableLabels, normalizeVariableLabel } from '~/components/AgreementStudioPage/TemplateVariables/TemplateVariables.utils';
export const SUBJECT_MAX_LENGTH = 120;
export function collectUnknownTemplateVariables(subject, message, allowedSystemKeys, customTemplateVariables) {
    const allowedNormalized = new Set();
    allowedSystemKeys.forEach((key)=>allowedNormalized.add(normalizeVariableLabel(key)));
    customTemplateVariables.forEach((name)=>allowedNormalized.add(normalizeVariableLabel(name)));
    const seen = new Set();
    const unknown = [];
    for (const name of [
        ...extractVariableLabels(subject),
        ...extractVariableLabels(message)
    ]){
        const normalized = normalizeVariableLabel(name);
        if (allowedNormalized.has(normalized) || seen.has(normalized)) continue;
        seen.add(normalized);
        unknown.push(name);
    }
    return unknown;
}
export function validateDraft(subject, message, allowedSystemKeys, customTemplateVariables) {
    let options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    const errors = {};
    if (!options.skipSubject) {
        const trimmedSubject = subject.trim();
        if (trimmedSubject.length === 0) {
            errors.subject = 'NOTIFICATION_V2_SUBJECT_EMPTY';
        } else if (/[\n\r]/.test(subject)) {
            errors.subject = 'NOTIFICATION_V2_SUBJECT_NEWLINE';
        } else if (trimmedSubject.length > SUBJECT_MAX_LENGTH) {
            errors.subject = 'NOTIFICATION_V2_SUBJECT_TOO_LONG';
        }
    }
    if (message.trim().length === 0) {
        errors.message = 'NOTIFICATION_V2_MESSAGE_EMPTY';
    }
    if (allowedSystemKeys != null) {
        const unknown = collectUnknownTemplateVariables(subject, message, allowedSystemKeys, customTemplateVariables !== null && customTemplateVariables !== void 0 ? customTemplateVariables : []);
        if (unknown.length > 0) errors.unknownTemplateVariables = unknown;
    }
    return errors;
}
export function isDraftValid(errors) {
    return errors.subject == null && errors.message == null && (errors.unknownTemplateVariables == null || errors.unknownTemplateVariables.length === 0);
}
